<app-gbg-step
  [title]="step().title"
  [description]="step().description"
  [state]="state()"
  [nextEnabled]="nextEnabled()"
  [hasError]="hasError()"
  [supportMessage]="supportMessage()"
  (previousClicked)="previous()"
  (nextClicked)="next()"
></app-gbg-step>
